import api from '@/api/app'
import { MessageBox } from 'element-ui'
import { removeToken } from '@/utils/auth'
const home = {
  Home: {
    viewInfo: {
      obj: {
        logoImg: require(`@/assets/logo/xuchang1.png`),
        menu1: [
          {
            path: '/mine/collect',
            type: 'path',
            label: '我的收藏'
          },
          {
            path: '/mine/set',
            type: 'path',
            label: '信息完善'
          },
          {
            path: 'logout',
            type: 'control',
            label: '退出'
          }
        ],
        footObj: {
          copyright: 'Copyright © 2022 All Rights Reserved.智加(郑州)工业互联网科技有限公司 版权所有',
          address: '郑州市金水区杨金路外包产业园天贞C座'
        }
      },
      data: {

      }
    },
    control: {
      /**
             * 描述
             * @date 2021-11-24
             * @param {any} condition
             * @returns {any}
             */
      isIndex0: (condition) => {
        return condition[0]
      },
      /**
             * 描述
             * @date 2021-11-24
             * @param {any} condition
             * @returns {any}
             */
      isShowMenu: (condition) => {
        if (condition[0].hidden) {
          return false
        } else {
          return true
        }
      }
    },
    init: {
      initConfigs: [],
      logout: () => {
        MessageBox.confirm('确认退出吗?', '提示', {})
          .then(() => {
            api.system.logout({}).then((res) => {
              removeToken()
              window.location.href = '/login'
            })
          })
          .catch(() => { })
      },
      number: () => {
        return new Promise((resolve) => {
          api.notes.retrieve.messageNoNumber().then((res) => {
            resolve(res.data.count)
          })
        })
      },
      // 调用消息列表的接口 把消息数量置为0
      data1: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.message(obj).then((res) => {
            resolve(res.data)
          })
        })
      }
    }
  },
  home: {
    viewInfo: {
      obj: {
        noticeBtns: [
          {
            label: '发布时间：',
            model: 'created_at',
            type: 'text',
            status: 0
          }
        ],
        noticeLeft: [
          {
            type: 'text',
            label: '新闻动态',
            model: '',
            url: require('@/assets/icon/gztz.png')
          }
        ],
        messageLeft: [
          {
            type: 'text',
            label: '消息通知',
            model: ''
          }
        ],
        informationLeft: [
          {
            type: 'text',
            label: '政策通知',
            model: '',
            url: require('@/assets/icon/equip.png')
          }
        ],
        helpLeft: [
          {
            type: 'text',
            label: '常见问题',
            model: '',
            url: require('@/assets/icon/cjwt.png')
          }
        ],
        squareLeft: [
          {
            type: 'text',
            label: '标准空间推荐',
            model: '',
            url: require('@/assets/icon/bzkj.png')
          }
        ],
        otherLeft: [
          {
            type: 'text',
            label: '相关网站',
            model: '',
            url: require('@/assets/icon/zxzt.png')
          }
        ],
        serveLeft: [
          {
            type: 'text',
            label: '常用应用',
            model: '',
            url: require('@/assets/icon/cyyy.png')
          }
        ],
        serveBtns: [
          {
            label: '优质课评选',
            jump: true,
            path: 'http://123.57.236.95:8506/'
          },
          // {
          //     label: "案例分析",
          //     path: "/school"
          // },
          {
            label: '建设专题申报',
            path: '/library'
          },
          // {
          //   label: '装备统计与申报',
          //   path: '/statistics'
          // },
          // {
          //   label: '空间建设指南',
          //   path: '/construction'
          // },
          {
            label: '学习园地',
            path: '/learn'
          },
          {
            label: '装备清单',
            path: '/proList'
          },
          {
            label: '联系我们',
            path: '/help/add'
          }


        ],
        otherBtns: [
          {
            path: 'http://www.moe.gov.cn/',
            url: require('@/assets/dto/jiaoyu.jpg'),
            title: '中华人民共和国教育部'
          },
          {
            path: 'http://jyt.henan.gov.cn/',
            url: require('@/assets/dto/shengTing.jpg'),
            title: '河南省教育厅'
          },
          {
            path: 'https://www.hnergc.cn/',
            url: require('@/assets/dto/baoZhang.jpg'),
            title: '河南省教育资源保障中心'
          },
          {
            path: 'http://jyj.xuchang.gov.cn/',
            url: require('@/assets/dto/xuChang.jpg'),
            title: '许昌市教育局'
          }

        ]
      },
      data: {
        imgList: [
          {
            type: 'mock',
            img: require(`@/assets/demo/home1-0.jpg`),
            path: 'https://720yun.com/t/a8vktwfw07b?scene_id=72776042'
          },
          {
            type: 'mock',
            img: require(`@/assets/demo/home1-1.jpg`),
            path: 'https://720yun.com/t/a8vktwfw07b?scene_id=72706944'
          },
          {
            type: 'mock',
            img: require(`@/assets/demo/home1-2.jpg`),
            path: 'https://720yun.com/t/a8vktwfw07b?scene_id=72776047'
          },
          {
            type: 'mock',
            img: require(`@/assets/demo/home1-3.jpg`),
            path: 'https://720yun.com/t/a8vktwfw07b?scene_id=72706947'
          },
          {
            type: 'mock',
            img: require(`@/assets/demo/home1-4.jpg`),
            path: 'https://720yun.com/t/a8vktwfw07b?scene_id=72776049'
          },
          {
            type: 'mock',
            img: require(`@/assets/demo/home1-5.jpg`),
            path: 'https://720yun.com/t/a8vktwfw07b?scene_id=72804544'
          },
          {
            type: 'mock',
            img: require(`@/assets/demo/home1-6.jpg`),
            path: 'https://720yun.com/t/a8vktwfw07b?scene_id=72804543'
          },
          {
            type: 'mock',
            img: require(`@/assets/demo/home1-7.jpg`),
            path: 'https://720yun.com/t/a8vktwfw07b?scene_id=72706957'
          }
        ],
        imgList1: [
          {
            type: 'mock',
            text: '郑州市第二十四中学',
            path: 'https://720yun.com/t/88vkzbdwdpy?scene_id=86402506'
          },
          {
            type: 'mock',
            text: '郑州市第一中学',
            path: null
          },
          {
            type: 'mock',
            text: '郑州市第二高级中学',
            path: null
          },
          {
            type: 'mock',
            text: '郑州市第四高级中学',
            path: null
          },
          {
            type: 'mock',
            text: '郑州市第五高级中学',
            path: null
          },
          {
            type: 'mock',
            text: '郑州市第七高级中学',
            path: null
          },
          {
            type: 'mock',
            text: '郑州市第八中学',
            path: null
          },
          {
            type: 'mock',
            text: '郑州市第十一高级中学',
            path: null
          },
          {
            type: 'mock',
            text: '郑州市第十二中学',
            path: null
          },
          {
            type: 'mock',
            text: '郑州市经济贸易学校',
            path: 'https://720yun.com/t/65vkblpbg29'
          }
        ]
      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [
        {
          label: 'data1',
          model: 'data1'
        },
        {
          label: 'data2',
          model: 'data2'
        },
        {
          label: 'data3',
          model: 'data3'
        },
        {
          label: 'data4',
          model: 'data4'
        }
      ],
      data2: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.notice(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map(item => {
                item.created_date = item.created_at
              })
            }

            resolve(res.data.data)
          })
        })
      },
      data3: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.information(obj).then((res) => {
            resolve(res.data.data)
          })
        })
      },
      data4: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.help(obj).then((res) => {
            resolve(res.data.data)
          })
        })
      },
      url: (obj) => {
        return new Promise((resolve) => {
          api.square.update.dto(obj).then((res) => {
            resolve(res.data.url)
          })
        })
      },
      squareImgs: (obj) => {
        return new Promise((resolve) => {
          api.square.retrieve.data(obj).then((res) => {
            resolve(res.data.data)
          })
        })
      },
      squareImgs1: (obj) => {
        return new Promise((resolve) => {
          api.square.retrieve.data(obj).then((res) => {
            console.log(res, 'squareImgs1')
          })
        })
      },
      controlImgs: (obj) => {
        return new Promise((resolve) => {
          api.school.retrieve.data(obj).then((res) => {
            resolve(res.data.data)
          })
        })
      },
      imgs: (obj) => {
        return new Promise((resolve) => {
          api.school.retrieve.dto(obj).then((res) => {
            const callData = {
              imgs: [],
              design: []
            }

            const obj = res.data[0]
            callData.design = obj.design
            const arr = []
            const obj1 = {}
            obj1.type = 'mock'
            obj1.cover_img = obj.cover_img
            obj1.path = obj.vr_url
            callData.imgs.push(obj1)
            obj.school_room.map(item => {
              item.type = 'mock'
              item.cover_img = item.img_urls[0]
              item.path = item.vr_url

              if (arr.length < 9) {
                callData.imgs.push(item)
              }
            })
            resolve(callData)
          })
        })
      }
    }
  }
}
export default home
